import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const Music = () => {
  return(
    <div id="site-sound">
      {/* 
      <audio autoPlay loop id="site-music-day">
        <source src={require("../assets/audio/Music_Day.mp3")} type="audio/mpeg"/>
        Your browser does not support the audio element
      </audio>
      <audio autoPlay loop muted id="site-music-night">
        <source src={require("../assets/audio/Music_Night.mp3")} type="audio/mpeg"/>
        Your browser does not support the audio element
      </audio>
      */}
    </div>
  );
}

const LayoutDefault = ({ children }) => (
  <>
    <main className="site-content">
      <Music/>
      <Header navPosition="right"/>
      {children}
      <Footer />
    </main>
    
  </>
);

export default LayoutDefault;  